import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import DraggableSprite from '../ui/DraggableSprite';
import SoundAssetKeys from '../SoundAssetKeys';
import JDialog from '../ui/JDialog';
import FontKeys from '../FontKeys';
import gameData from '../gameData';
import { addJumpAnimationsToSprite } from '../AnimationManager';
import StateButton from '../ui/StateButton';
import { transitionScene } from '../SceneTransition';
import IntroScreen from './IntroScreen';

export default class DragOrderScreen extends Phaser.Scene {
  static get KEY() { return 'DragOrderScreen'; }

  constructor() {
    super({ key: DragOrderScreen.KEY });
  }

  init() {
    // drag fix
    this.input.on(Phaser.Input.Events.GAME_OUT, (time, event) => {
      if (event instanceof MouseEvent) {
        this.input.manager.onMouseUp(event);
      }
    });
  }

  create() {
    this.isJumping = false;
    this.totalAnswersCorrect = 0;
    this.dialog = null;

    DraggableSprite.instances = [];

    this.background = ABCyaPhaser.Images.addImage(0,-(1100 - 768),UIAssetKeys._TempleBckgDays, this).setOrigin(0);

    const dayNames = { Sunday: 1, Monday: 2, Tuesday: 3, Wednesday: 4, Thursday: 5, Friday: 6, Saturday: 7 };

    // make targets
    this.targets = [];
    this.dayTiles = [];

    const dayKeys = Object.keys(dayNames);

    for (let i = 0; i < dayKeys.length; i++) {
      const tile = ABCyaPhaser.Images.addImage(this.scale.width / 2 - 345 + (i * 115),this.scale.height / 2 + 50, `TileSlot${i + 1}Days`, this);
      tile.number = i + 1;
      tile.scale = 0.75;

      this.targets.push(tile);
    }

    // make draggable days
    const dayNamesRandom = Phaser.Utils.Array.Shuffle(dayKeys);

    for (let i = 0; i < dayNamesRandom.length; i++) {
      const name = dayNamesRandom[i];

      const dayNumber = dayNames[name];

      const day = new DraggableSprite(this, `${name}Tile`);
      day.hitTarget = this.targets;
      day.originalX = 160 + (i * 115);
      day.originalY = 200;
      day.x = day.originalX;
      day.y = day.originalY;
      day.hitListener = this.targetHit.bind(this);
      day.outListener = this.targetOut.bind(this);
      day.faceValue = 100;
      day.scale = 0.75;
      day.number = dayNumber;

      this.add.existing(day);
      this.dayTiles.push(day);
    }

    this.dragInstructions = ABCyaPhaser.Images.addImage(this.scale.width / 2, this.scale.height / 2 - 65, UIAssetKeys._drag_instructions, this);

    // gold coin chest
    this.chest = ABCyaPhaser.Images.addImage(this.scale.width / 2, this.scale.height / 2 - 650, UIAssetKeys._ChestInsideAndFront, this);

    this.coins = [];

    for (let i = 0; i < 100; i++) {
      const x = Phaser.Math.Between(0, 150) - 75;
      const y = Phaser.Math.Between(0, 70) - 35;

      const coin = ABCyaPhaser.Images.addImage(this.scale.width / 2 + x, this.scale.height / 2 - 650 + y, UIAssetKeys._Coin, this);
      this.coins.push(coin);
    }

    this.chestLid = ABCyaPhaser.Images.addImage(this.scale.width / 2, this.scale.height / 2 - 650, UIAssetKeys._ChestLidDays, this);


    if (gameData.INSTRUCTIONS2_SEEN) {
      this.time.delayedCall(1000, this.continueClicked, null, this);
    }
    else {
      gameData.INSTRUCTIONS2_SEEN = true;
      this.time.delayedCall(1000, this.makeFirstDialog, null, this);
    }

    this.jingle = ABCyaPhaser.Audio.createSound(this);
    ABCyaPhaser.Audio.playSound(SoundAssetKeys._Temple_Theme, this.jingle, 1, true);

    this.speakerButton = new StateButton(this, UIAssetKeys._UnmuteBtnDays, UIAssetKeys._MuteBtn);
    this.add.existing(this.speakerButton);
    this.speakerButton.x = this.scale.width - 40;
    this.speakerButton.y = this.scale.height - 40;

    this.speakerButton.doAction1 = () => {
      this.jingle.mute = false;
      gameData.muteJingle = false;
    };
    this.speakerButton.doAction2 = () => {
      this.jingle.mute = true;
      gameData.muteJingle = true;
    };

    if (gameData.muteJingle) {
      this.jingle.mute = true;
      this.speakerButton.switchStateOff();
    }

    DraggableSprite.disableAll();
  }

  /**
   * 
   * @param {DraggableSprite} dragTile 
   */
  targetHit (dragTile) {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._drop_tile, this);

    dragTile.snapToTarget();

    // check
    if (DraggableSprite.checkAllTargetsMatchTiles()) {
      this.doWinScenario();
    }
  }

  doWinScenario () {
    // remove all elements from temple scene
    // remove instructions

    ABCyaPhaser.Tweens.addTween(this.dragInstructions, 1000, { x: this.dragInstructions.x + 1000 }, Phaser.Math.Easing.Linear, () => this.dragInstructions.destroy());

    // remove day tiles
    for (let i = 0; i < this.dayTiles.length; i++) {
      const tile = this.dayTiles[i];

      tile.disableInteractive();

      ABCyaPhaser.Tweens.addTween(tile, 1000, { delay: (i + 1) * 200, scale: 0 }, Phaser.Math.Easing.Linear, () => tile.destroy());
    }

    // remove targets
    for (let i = 0; i < this.targets.length; i++) {
      const target = this.targets[i];

      ABCyaPhaser.Tweens.addTween(target, 1000, { delay: ((i + 1) * 200) + 1400, scale: 0 }, Phaser.Math.Easing.Linear, () => target.destroy());
    }

    // create stones to jump on
    this.time.delayedCall(3000, this.makePlatformsAcrossTemple, null, this);

    ABCyaPhaser.Tweens.addTween(this.chestLid, 1500, { delay: 11000, onStart: () => this.playFanFare(), y: this.chestLid.y - 120, completeDelay: 500 }, Phaser.Math.Easing.Linear, () => this.makeGoldExplosion());
  }

  makePlatformsAcrossTemple () {
    for (let i = 0; i < 4; i++) {
      const platform = ABCyaPhaser.Images.addImage(this.scale.width / 2 - 600, this.scale.height / 2 + 175 - (i * 157), UIAssetKeys._PlatformDays, this);
      platform.scale = 0.80;

      this.children.bringToTop(this.jumpAnimationContainer);

      ABCyaPhaser.Tweens.addTween(platform, 1000, { delay: i * 300, x: platform.x + 600 }, Phaser.Math.Easing.Bounce.Out);
    }

    const yAdjust = -320;

    this.tweens.add({
      targets: this.cameras.main,
      duration: 6000,
      delay: 1000,
      ease: Phaser.Math.Easing.Linear,
      props: { scrollY: yAdjust }
    });

    this.time.delayedCall(2000, this.jumpToTreasure, null, this);

    this.addScaryEyes();
  }

  jumpToTreasure () {
    for (let i = 0; i < 5; i++) {
      this.time.delayedCall(i * 1000, this.jump, [this.jumpAnimation.x + 10, 590 - (i * 157)], this);
    }
  }

  jump (x, y) {
    this.isJumping = true;
    this.jumpAnimation.play('Jump');

    // eslint-disable-next-line no-param-reassign
    x -= 15;
    // eslint-disable-next-line no-param-reassign
    y -= this.jumpAnimation.height / 2 - 20;

    ABCyaPhaser.Tweens.addTween(this.jumpAnimation, 400, { delay: 400, x,y }, Phaser.Math.Easing.Linear, () => this.jumpAnimation.stop().setFrame(UIAssetKeys._jump_1));
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._Jump_Land, this, 1, false, 0.7);
  }

  addScaryEyes () {
    // left
    for (let i = 0; i < 10; i++) {
      const randEyes = Phaser.Utils.Array.GetRandom(['Eyes1', 'Eyes2']);
      const randScale = Phaser.Math.Between(3,7) / 10;

      const randX = -1 * Phaser.Math.Between(150, 350);
      const randY = (1 * Phaser.Math.Between(200, 250)) + (-60 * i);

      const scaryEyes1 = ABCyaPhaser.Images.addImage(this.scale.width / 2 + randX,this.scale.height / 2 + randY, randEyes, this);
      scaryEyes1.alpha = 0;
      scaryEyes1.scale = randScale;

      ABCyaPhaser.Tweens.addTween(scaryEyes1, 1000, { delay: i * 600, alpha: 1 }, Phaser.Math.Easing.Linear, () => {
        ABCyaPhaser.Tweens.addTween(scaryEyes1, 4000, { alpha: 0 }, Phaser.Math.Easing.Linear);
      });
    }

    // right
    for (let i = 0; i < 10; i++) {
      const randEyes = Phaser.Utils.Array.GetRandom(['Eyes3', 'Eyes4']);
      const randScale = Phaser.Math.Between(3,7) / 10;

      const randX = 1 * Phaser.Math.Between(150, 350);
      const randY = (1 * Phaser.Math.Between(200, 250)) + (-60 * i);

      const scaryEyes1 = ABCyaPhaser.Images.addImage(this.scale.width / 2 + randX,this.scale.height / 2 + randY, randEyes, this);
      scaryEyes1.alpha = 0;
      scaryEyes1.scale = randScale;

      ABCyaPhaser.Tweens.addTween(scaryEyes1, 1000, { delay: i * 600, alpha: 1 }, Phaser.Math.Easing.Linear, () => {
        ABCyaPhaser.Tweens.addTween(scaryEyes1, 4000, { alpha: 0 }, Phaser.Math.Easing.Linear);
      });
    }
  }

  playFanFare () {
    this.jingle.stop();
    this.jingle.destroy();

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._Completed_Game, this);
  }

  makeGoldExplosion () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._Gold_Fall, this);

    for (let i = this.coins.length - 1; i > -1; i--) {
      const coin = this.coins[i];

      this.children.moveTo(coin, this.children.length - 2);

      const x = Phaser.Math.Between(100, 900);
      const y = Phaser.Math.Between(-50, -250);

      let x2 = -50;
      const y2 = Phaser.Math.Between(500, 900);

      if (x > this.scale.width / 2) {
        x2 = 50;
      }

      ABCyaPhaser.Tweens.addTween(coin, 350, { x,y, delay: i * 5 }, Phaser.Math.Easing.Linear, () => {
        ABCyaPhaser.Tweens.addTween(coin, 1400, { x: x + x2, y: y2 }, Phaser.Math.Easing.Linear);
      });

      ABCyaPhaser.Tweens.addTween(coin, 200, { scaleX: 3, scaleY: 4, delay: i * 5 }, Phaser.Math.Easing.Linear, () => {
        ABCyaPhaser.Tweens.addTween(coin, 300, { scaleX: 4, scaleY: 4 }, Phaser.Math.Easing.Linear, () => {
          ABCyaPhaser.Tweens.addTween(coin, 550, { scaleX: 0.5, scaleY: 0.5 }, Phaser.Math.Easing.Linear);
        });
      });
    }

    this.time.delayedCall(1000, this.makeDialog2, null, this);
  }

  makeDialog2 () {
    this.dialog = new JDialog(this, UIAssetKeys._PopupBckg, UIAssetKeys._PlayAgainBtnDays);
    this.add.existing(this.dialog);
    this.dialog.doAction1 = this.playAgainClicked.bind(this);
    this.dialog.setPosition(this.scale.width / 2,this.scale.height / 2 + 250);
    this.dialog.button1.x += 270;
    this.dialog.button1.y -= 145;

    this.dialog.y += 400;

    this.text1 = ABCyaPhaser.Text.addText(-60, -20, '24pt', 0xFFF4B6, FontKeys._rifficregular, 'Great Job! We got the treasure!', this.dialog).setOrigin(0.5, 0);
    this.text2 = ABCyaPhaser.Text.addText(-140, 80, '24pt', 0xFFF4B6, FontKeys._rifficregular, 'Want to play again?', this.dialog).setOrigin(0.5, 0);

    const yAdjust = 830 - 95;

    ABCyaPhaser.Tweens.addTween(this.dialog, 2000, { delay: 500, y: this.dialog.y - yAdjust }, Phaser.Math.Easing.Bounce.Out);

    this.time.delayedCall(1500, this.playDialogWinSound, null, this);
  }

  playDialogWinSound () {
    this.winVO = ABCyaPhaser.Audio.createSound(this);
    ABCyaPhaser.Audio.playSound(SoundAssetKeys._4_We_Got_the_Treasure, this.winVO);
  }

  /**
   * 
   * @param {DraggableSprite} dragTile 
   */
  targetOut (dragTile) {
    dragTile.moveToOriginalPosition();
  }

  continueClicked() {
    this.dialogVO?.stop();
    this.dialogVO?.destroy();
    this.dialogVO = null;

    if (this.dialog) {
      const yAdjust = 726;
      this.dialog.enabled = false;
      ABCyaPhaser.Tweens.addTween(this.dialog, 2000, { y: this.dialog.y + yAdjust }, Phaser.Math.Easing.Linear);
    }

    this.time.delayedCall(1000, this.enableDrag, null, this);

    this.time.delayedCall(1500, this.createMan, null, this);
  }

  enableDrag () {
    DraggableSprite.enableAll();
  }

  createMan () {
    // create static man
    this.jumpAnimation = this.add.sprite(0,0,ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._jump_1);
    this.jumpAnimationContainer = this.add.container(-this.jumpAnimation.width / 2, -this.jumpAnimation.height / 2, this.jumpAnimation);
    addJumpAnimationsToSprite(this.jumpAnimation);

    this.jumpAnimation.x = -67;
    this.jumpAnimation.y = 841;

    this.moveManToStart();
  }

  moveManToStart () {
    // always make man be on top of questions which are newly generated
    this.children.bringToTop(this.jumpAnimation);

    this.jumpAnimation.alpha = 1;

    // perform jump
    this.isJumping = true;

    this.jumpAnimation.play('Jump');

    const yAdjust = 400;
    ABCyaPhaser.Tweens.addTween(this.jumpAnimation, 700, { delay: 100, x: this.jumpAnimation.x + 575, y: this.jumpAnimation.y + 170 - yAdjust }, Phaser.Math.Easing.Linear, () => this.jumpAnimation.stop().setFrame(UIAssetKeys._jump_1));
  }

  makeFirstDialog () {
    this.dialog = new JDialog(this,UIAssetKeys._PopupBckg, UIAssetKeys._ContinueBtnDays);
    this.add.existing(this.dialog);
    this.dialog.doAction1 = this.continueClicked.bind(this);
    this.dialog.setPosition(this.scale.width / 2, this.scale.height / 2 + 250);
    this.dialog.button1.x += 270;
    this.dialog.button1.y -= 145;

    this.dialog.y += 700;

    this.text1 = ABCyaPhaser.Text.addText(-60, -20, '24pt', 0xFFF4B6, FontKeys._rifficregular, 'Drag the days into the correct', this.dialog).setOrigin(0.5, 0);
    this.text2 = ABCyaPhaser.Text.addText(-116, 20, '24pt', 0xFFF4B6, FontKeys._rifficregular, 'order to cross the gap!', this.dialog).setOrigin(0.5, 0);
    this.text3 = ABCyaPhaser.Text.addText(-140, 80, '24pt', 0xFFF4B6, FontKeys._rifficregular, 'We\'re almost there!', this.dialog).setOrigin(0.5, 0);

    const yAdjust = 726;
    ABCyaPhaser.Tweens.addTween(this.dialog, 2000, { delay: 500, y: this.dialog.y - yAdjust }, Phaser.Math.Easing.Bounce.Out);

    this.dialogVO = ABCyaPhaser.Audio.createSound(this);
    ABCyaPhaser.Audio.playSound(SoundAssetKeys._3_Drag_the_Days, this.dialogVO, 1, false, 1.5);
  }

  playAgainClicked () {
    this.winVO.stop();
    this.winVO.destroy();
    this.dialog.enabled = false;

    transitionScene(this, IntroScreen.KEY, 'horizontal');
  }
}